
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont les effets secondaires?`}</em></p>
    <p>{`Comme celui d'AstraZeneca, qui utilise la même technologie, ce vaccin a fait
l'objet d'une polémique suite à l'annonce de rares cas de
`}<a parentName="p" {...{
        "href": "548810620632"
      }}>{`thromboses`}</a>{`. Pour cette raison, le Danemark et la Finlande y ont
renoncé et certains pays ne le proposent qu’à partir d’un certain âge.`}</p>
    <p>{`Le 29 septembre, alors que la Suisse annonçait sa commande, la Slovénie a
suspendu par précaution l’utilisation de ce produit suite au décès d’une femme
de 20 ans. Selon des médias locaux, elle a succombé à une hémorragie cérébrale
et à des caillots sanguins.`}</p>
    <p>{`“Ce risque est connu, commente Blaise Genton. Il concerne davantage les jeunes
femmes mais reste faible puisqu’il touche huit personnes sur un million chez les
moins de 50 ans et une personne sur 100 millions chez les plus de 50 ans. En
comparaison, les risques liés au Covid sont bien plus élevés.”`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;